import {
  validationCompanyNameRegex,
  validationNameRegex,
} from 'src/common/regex';
import {
  getFlowFormValidationRuleWithRequirement,
  requiredValidation,
} from 'src/common/validation';
import SchemaTyped from 'rsuite/esm/Schema/Schema';

const { StringType } = SchemaTyped.Types;
export const getPropertyManagerValidationModel = (
  optionalFields: Record<string, unknown>
) => ({
  firstName: getFlowFormValidationRuleWithRequirement(
    'firstName',
    optionalFields,
    StringType().pattern(validationNameRegex, 'Must be all letters')
  ),
  lastName: getFlowFormValidationRuleWithRequirement(
    'lastName',
    optionalFields,
    StringType().pattern(validationNameRegex, 'Must be all letters')
  ),
  companyName: getFlowFormValidationRuleWithRequirement(
    'companyName',
    { companyName: 'optional' },
    StringType().pattern(
      validationCompanyNameRegex,
      'Company names must begin with ., @, & or an alphanumeric character.  The remainder of the name may only include -, !, ., @, &, (, ), alphanumeric characters or a single space character.'
    )
  ),
  email: getFlowFormValidationRuleWithRequirement(
    'email',
    optionalFields,
    StringType().isEmail()
  ),
  phone: getFlowFormValidationRuleWithRequirement(
    'phone',
    optionalFields,
    StringType().pattern(/^\d{10}$/, 'A 10 digit phone number is required')
  ),
  mailingAddress: requiredValidation,
});

export const getOwnerRepValidationModel = (
  optionalFields: Record<string, unknown>
) => ({
  firstName: getFlowFormValidationRuleWithRequirement(
    'firstName',
    optionalFields,
    StringType().pattern(validationNameRegex, 'Must be all letters')
  ),
  lastName: getFlowFormValidationRuleWithRequirement(
    'lastName',
    optionalFields,
    StringType().pattern(validationNameRegex, 'Must be all letters')
  ),
  companyName: getFlowFormValidationRuleWithRequirement(
    'companyName',
    { companyName: 'optional' },
    StringType().pattern(
      validationCompanyNameRegex,
      'Company names must begin with ., @, & or an alphanumeric character.  The remainder of the name may only include -, !, ., @, &, (, ), alphanumeric characters or a single space character.'
    )
  ),
  email: getFlowFormValidationRuleWithRequirement(
    'email',
    optionalFields,
    StringType().isEmail()
  ),
  phone: getFlowFormValidationRuleWithRequirement(
    'phone',
    optionalFields,
    StringType().pattern(/^\d{10}$/, 'A 10 digit phone number is required')
  ),
  mailingAddress: requiredValidation,
});
